import { render, staticRenderFns } from "./promise-loading-button.vue?vue&type=template&id=6bb8db71&"
import script from "./promise-loading-button.vue?vue&type=script&lang=js&"
export * from "./promise-loading-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports